// removed by extract-text-webpack-plugin
module.exports = {"pre":"_27HjRpnxjCvJWHvBJctYpz","textarea":"_1nPn1Q7_ajDRJJgco88OjR","genbank":"CnvzYiAfEpAoCiOOil52O"};


//////////////////
// WEBPACK FOOTER
// ./src/views/wizard/isolate/genbank/style.css
// module id = 373
// module chunks = 0